<div *ngIf="!config?.ui?.hideToolbar" class="filters mb-3" [class.has-sidebar]="hasSidebar" [formGroup]="filterForm">
	<ng-container *ngFor="let filter of filters">
		<app-filter-input
			[darkMode]="true"
			[style.flex-grow]="filter.grow === false ? 0 : 1"
			[class.no-top-padding]="filter.topPadding === false"
			[filter]="filter"
			[formGroup]="filterForm"
			[prefixIcon]="filter.prefixIcon"
		></app-filter-input>
	</ng-container>

	<div class="filter-selectors" *ngIf="config.datasource.config.sortableFields?.length > 0">
		<mat-form-field appearance="fill" *ngIf="filterForm.get('sort')">
			<mat-label i18n="Asset Picker Sort By Label@@assetPickerSortByLabel">Sort By:</mat-label>
			<mat-select formControlName="sort" placeholder="Sort By" i18n-placeholder="Asset Picker Sort By Placeholder@@assetPickerSortByPlaceholder">
				<mat-option [value]="sortableField.path" *ngFor="let sortableField of config.datasource.config.sortableFields">
					<div *ngIf="sortableField.displayName | transformObject: localizeSort: sortTranslations as localSort">
						{{ localSort }}
					</div>
				</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="fill" *ngIf="filterForm.get('sortStrategy')">
			<mat-label i18n="Asset Picker Sort Direction Label@@assetPickerSortDirectionLabel">Sort Direction</mat-label>
			<mat-select formControlName="sortStrategy" placeholder="Sort Direction" i18n-placeholder="Asset Picker Sort Direction Placeholder@@assetPickerSortDirectionPlaceholder">
				<mat-option [value]="dir" *ngFor="let dir of Object.values(SortDirection)">
					<div *ngIf="dir | transformObject: localizeSortDirection: sortDirectionTranslations as localSortDirection">
						{{ localSortDirection }}
					</div>
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<!-- <button mat-flat-button [matMenuTriggerFor]="menu" class="filter-button pl-0" *ngIf="ui.showMoreFilters && ui.customFilters?.length" [color]="(currentFilters | transformObject: isCustomFilterActive) ? 'primary' : undefined">
		<mat-icon inline>filter_alt</mat-icon>
		Filter
	</button>
	<mat-menu #menu="matMenu" class="dark-color">
		<div class="filter-dropdown-container p-4">
			<ng-container *ngFor="let customFilter of ui.customFilters">
				<mat-label>{{customFilter.name}}</mat-label>
				<mat-form-field class="form-control form-field dark-color" appearance="fill">
					<mat-select
						placeholder="All"
						[multiple]="customFilter.selectionType === 'multiple'"
						[value]="customFilter.selectionType === 'multiple' ? currentFilters?.customFilters?.[customFilter.key] : currentFilters?.customFilters?.[customFilter.key]?.[0] " (click)="$event.stopPropagation()"
						(selectionChange)="onCustomFilterChange(customFilter, $event.value)"
					>
						<mat-option *ngIf="customFilter.selectionType === 'single'" [value]="''">All</mat-option>
						<mat-option *ngFor="let option of (customFilter | transformObject: getCustomFilterValues: elements)" [value]="option.value">{{option.label | titlecase}}</mat-option>
					</mat-select>
				</mat-form-field>
			</ng-container>
		</div>
	</mat-menu> -->

	<!-- <mat-button-toggle-group aria-label="View toggle" [value]="viewMode" (change)="this.viewMode = $event.value" *ngIf="ui.showSelectViewMode">
		<mat-button-toggle value="card">
			<mat-icon>apps</mat-icon>
		</mat-button-toggle>
		<mat-button-toggle value="list">
			<mat-icon>list_ul</mat-icon>
		</mat-button-toggle>
	</mat-button-toggle-group> -->
</div>

<div class="content-container picker-content {{gridLayoutClass}}">
	<app-collection-container [collection]="collection">

		<ng-template #cardTemplate let-item>

			<div class="card {{item?.mediaType}}" (click)="selectItem.emit(item)" [class.selected]="selectedItems | searchArrayBy:'id':item.id">
				<ng-container>
					<button
						class="menu-btn"
						mat-icon-button
						*ngIf="item?.assetPath && (enableRemoveFromCollection || isSuperAdmin || canShowDelete(item))"
						type="button"
						[matMenuTriggerFor]="collectionMenu"
						[matMenuTriggerData]="{ item: item }"
						(click)="openCollectionMenu($event, item); $event.stopPropagation()"
					>
						<mat-icon class="m-0">more_vert</mat-icon>
					</button>
				</ng-container>
				<div class="preview">
					<ng-container [ngSwitch]="item?.mediaType">
						<ng-container *ngSwitchCase="'image'">
							<img class="thumb image" [src]="(item?.poster || item?.assetPath) | cloudinaryImageTransform:{ height: config.ui?.layout?.height || '200', mode: 'limit' }" [alt]="item?.name || item?.title">
						</ng-container>
						<ng-container *ngSwitchCase="'video'">
							<video class="thumb video" [src]="item?.poster || item?.assetPath" controls preload="none" [poster]="(item?.poster || item?.assetPath) | cloudinaryVideoTransform:{ adv: 'f_jpg', height: config.ui?.layout?.height || '200', width: config.ui?.layout?.width || '200', mode: 'limit' }"></video>
						</ng-container>
						<ng-container *ngSwitchCase="'audio'">
							<app-asset-picker-audio-preview
								[item]="item"
								[activePreviewId]="activePreviewId"
								(activePreviewIdChange)="activePreviewId = $event"
							></app-asset-picker-audio-preview>
						</ng-container>
						<ng-container *ngSwitchDefault>
							<img *ngIf="item?.poster" class="thumb image" [src]="item?.poster" [alt]="item?.name || item?.title">
							<mat-icon *ngIf="!item?.poster" class="thumb file">insert_drive_file</mat-icon>
						</ng-container>
					</ng-container>
				</div>

				<div class="card-body">
					<h5 class="card-title m-0" [title]="item.name || item.title">{{ item?.name || item?.title }}</h5>
					<span class="tags-list" *ngIf="item.tags?.length > 0">
						<mat-basic-chip disableRipple class="tag-item" *ngFor="let tag of item.tags" color="primary">
							{{ tag }}
						</mat-basic-chip>
					</span>
				</div>
			</div>

		</ng-template>

	</app-collection-container>
</div>

<mat-menu #collectionMenu="matMenu" class="tiny" (closed)="onMenuClosed()">
	<ng-container *matMenuContent="let item = item">
		<button
			mat-menu-item
			*ngIf="menuAsset && enableRemoveFromCollection"
			(click)="onRemoveFromCollection($event); $event.stopPropagation()"
			i18n="Asset Picker Remove From Collection@@assetPickerRemoveFromCollection"
		>
			<mat-icon>remove_circle_outline</mat-icon>
			<span>Remove from collection</span>
		</button>
		<button
			mat-menu-item
			*ngIf="!hideDefaultMenuItems && canShowDelete(item)"
			(click)="confirmDelete(item); $event.stopPropagation()"
			i18n="Asset Picker Delete Asset@@assetPickerDeleteAsset"
		>
			<span>Delete Asset</span>
		</button>
		<button mat-menu-item *ngIf="!hideDefaultMenuItems && isSuperAdmin && canAssociateWithBusiness" (click)="associateWithBusiness(item)">
			<span i18n="Associate Business Title@@associateBusinessDialogTitle">Associate with business</span>
		</button>
	</ng-container>
</mat-menu>
